module.exports = __webpack_public_path__ + "static/kwsLogo-f42dc322fe5136d08df87a269b87e6f7.jpg";